export default __webpack_public_path__ + "static/media/nantes.368f821a.jpg";